import { useState } from 'react';
import { Circles } from 'react-loading-icons';

export default function GameRatingHeader({ content }) {
  const [showFullDesc, setShowFullDesc] = useState(false);

  const toggleDescription = () => setShowFullDesc(!showFullDesc);

  const getDescription = () => {
    if (!content?.description_raw) return '';
    if (showFullDesc || content.description_raw.length <= 500) {
      return content.description_raw;
    }
    return content.description_raw.slice(0, 500) + '...';
  };

  return (
    <>
      {content && content.tags ? (
        <div className="flex flex-col lg:flex-row items-center justify-center gap-8 p-4 sm:p-6 md:p-10 max-w-screen-xl mx-auto">
          <img
            src={content.background_image}
            className="rounded-xl border-2 aspect-video w-full max-w-md sm:max-w-lg md:max-w-xl lg:max-w-lg"
            loading="lazy"
            alt={content.name}
          />

          <div className="flex flex-col gap-4 text-center lg:text-left max-w-3xl px-4">
            <h2 className="text-white font-bold text-3xl sm:text-4xl md:text-5xl font-hind pt-4 lg:pt-0">
              {content.name}
            </h2>

            <h3 className="text-faded font-hind text-sm sm:text-base md:text-lg text-justify">
              {getDescription()}
              {content.description_raw.length > 500 && (
                <button
                  onClick={toggleDescription}
                  className="text-blue-400 ml-1 underline text-sm"
                >
                  {showFullDesc ? 'Show Less' : 'Read More'}
                </button>
              )}
            </h3>

            <h4 className="text-faded font-hind text-base sm:text-lg">
              <span className="font-bold">Released</span>: {content.released}
            </h4>

            <div className="flex flex-wrap gap-3 justify-center lg:justify-start">
              {content.tags.map((genre, index) => (
                <div
                  key={index}
                  className="rounded-3xl text-sm font-hind text-faded px-4 py-2 bg-blue-950 whitespace-nowrap"
                >
                  {genre.name}
                </div>
              ))}
            </div>
          </div>
        </div>
      ) : (
        <div className="grid place-items-center min-h-[200px]">
          <Circles />
        </div>
      )}
    </>
  );
}
